/**
 * One-time migration of localStorage/sessionStorage keys from swipematch-* to traitprint-*.
 * Runs once on startup and sets a sentinel to avoid re-running.
 */
const MIGRATION_SENTINEL = "traitprint:storage-migrated";

export function migrateStorageKeys(): void {
  if (localStorage.getItem(MIGRATION_SENTINEL)) return;

  migrateStore(localStorage);
  migrateStore(sessionStorage);

  localStorage.setItem(MIGRATION_SENTINEL, "1");
}

function migrateStore(store: Storage): void {
  const keysToMigrate: string[] = [];

  for (let i = 0; i < store.length; i++) {
    const key = store.key(i);
    if (
      key &&
      (key.startsWith("swipematch-") ||
        key.startsWith("swipematch_") ||
        key.startsWith("swipematch:"))
    ) {
      keysToMigrate.push(key);
    }
  }

  for (const oldKey of keysToMigrate) {
    const newKey = oldKey.replace(/^swipematch/, "traitprint");
    if (!store.getItem(newKey)) {
      store.setItem(newKey, store.getItem(oldKey)!);
    }
    store.removeItem(oldKey);
  }
}
